import { toastr } from 'react-redux-toastr';

import Config from '../../config';
import {
  readUsersAndPrivilegesFile,
} from './xlsxImport.helpers';
import { ExcelUser } from '../../shared/queries/users';
import { userRolesLabelToNameDictionary } from '../../shared/authorization/userRoles';

export type HandleUsersUploadParams = {
  file: File,
  uploadUsersApi: (excelUsersRows: ExcelUser[]) => void,
};

export const handleUsersUpload = async ({ file, uploadUsersApi }: HandleUsersUploadParams) => {
  try {
    const users = await readUsersAndPrivilegesFile(file);
    await uploadUsersApi(users.map(
      ({ roleName, ...rest }) => ({ ...rest, roleName: userRolesLabelToNameDictionary[roleName] || roleName })
    ));
  } catch (error: any) {
    toastr.error('', error.message, Config.defaultToastrSettings);
  }
};
